import { forwardRef, memo, useCallback } from 'react';
// Skillmore UI Components
import ItemCard from '@empathco/ui-components/src/elements/ItemCard';
import TargetIcon from '@empathco/ui-components/src/elements/TargetIcon';
// local imports
import { Skill } from '../models/skill';
// SCSS imports
import { root, icon, iconInactive } from './SelectableSkillCard.module.scss';

type SelectableSkillCardProps = {
  readonly skill: Skill;
  readonly onClick?: (skill: Skill) => void;
  readonly disabled?: boolean | null;
}

const SelectableSkillCard = forwardRef<HTMLDivElement, SelectableSkillCardProps>(({
  skill,
  disabled = false,
  onClick
}, ref) => {
  const { title, is_target } = skill || {};
  const isTarget = Boolean(is_target);

  const handleClick = useCallback(() => {
    if (onClick && skill && skill.id) onClick(skill);
  }, [onClick, skill]);

  return (
    <ItemCard
        ref={ref}
        small
        active={isTarget}
        onClick={disabled ? undefined : handleClick}
        className={root}
    >
      <TargetIcon
          small
          active={isTarget}
          disabled={disabled}
          className={isTarget ? icon : iconInactive}
      />
      {title}
    </ItemCard>
  );
});

SelectableSkillCard.displayName = 'SelectableSkillCard';

export default memo(SelectableSkillCard);
